import builder from '@rsql/builder';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import React, { useContext, useRef } from 'react';
import { useParams } from 'react-router-dom';
import ButtonSeplag from '../../../../../components/buttonSeplag/ButtonSeplag';
import RotuloSeplag from '../../../../../components/rotuloSeplag/RotuloSeplag';
import Pages from '../../../../../config/Pages';
import { ApplicationContext } from '../../../../../config/Router';
import PageMessages from '../../../../../config/translations/PageMessages';
import { MultipageContext } from '../../../../../core/components/Multipage';
import InputDropDown from '../../../../../core/components/inputs/inputDropDown/InputDropDown';
import BasePage from '../../../../../core/page/BasePage';
import BaseFilter from '../../../../../core/page/components/baseFilter/BaseFilter';
import { useInputs } from '../../../../../core/utils/Hooks';
import metaService from '../../../../../service/MetaService';
import situacaoMetaService from '../../../../../service/SituacaoMetaService';
import { metaInputs } from '../../PageInputs';
import styles from './MetasList.module.scss';
import ModalCancelarMeta from './modalCancelar/ModalCancelarMeta';
import ModalMetas from './modalMetas/ModalMetas';

function MetasList() {
    const { id: idIndicador } = useParams();
    const filterInputs = useInputs(metaInputs);

    const modalRef = useRef(null);
    const modalCancelarRef = useRef(null);
    const baseFilterRef = useRef(null);
    const { confirmRef, confirmOkRef } = useContext(MultipageContext);
    const { situacaoIndicador, periodicidadeIndicador, unidadeMedida } =
        useContext(ApplicationContext);
    const Rotulo = ({ children, ...rest }) => (
        <RotuloSeplag useInput={filterInputs} {...rest}>
            {children}
        </RotuloSeplag>
    );
    const Inputs = ({ formik }) => (
        <>
            <Rotulo>
                <InputText
                    name="numMeta"
                    keyfilter="int"
                    onChange={formik.handleChange}
                    value={formik.values.numMeta}
                />
            </Rotulo>
            <Rotulo>
                <InputText
                    name="descMeta"
                    onChange={formik.handleChange}
                    value={formik.values.descMeta}
                />
            </Rotulo>
            <Rotulo>
                <InputDropDown
                    name="situacao"
                    formik={formik}
                    optionLabel="descSituacaoMeta"
                    callbackSetList={situacaoMetaService.list.bind(situacaoMetaService)}
                />
            </Rotulo>
        </>
    );
    return (
        <>
            <ModalMetas
                ref={modalRef}
                confirmRef={confirmRef}
                onSave={(dontCloseModal = false) => {
                    if (!dontCloseModal) {
                        modalRef.current.hide();
                    }
                    baseFilterRef.current.formik.submitForm();
                }}
            />
            <ModalCancelarMeta
                ref={modalCancelarRef}
                onSave={() => {
                    modalCancelarRef.current.hide();
                    baseFilterRef.current.formik.submitForm();
                }}
            />
            <BasePage
                LayoutDefault={({ children }) => <div className={styles.page}>{children}</div>}
                page={{
                    pageUrls: Pages.sei.metasResultados.url,
                    legenda: Pages.sei.metasResultados.legenda,
                    pageName: Pages.sei.metasResultados.title,
                }}
                service={metaService}
                onSetList={(response, config) => {
                    return metaService.beforeSetList(
                        response.map((el) => ({
                            ...el,
                            indicador: {
                                unidadeMedida,
                                periodicidadeIndicador,
                            },
                        })),
                        config
                    );
                }}
                initialValues={metaInputs.filter((el) => el?.table?.use ?? false)}
                enableAdicionar={false}
                enableEditar={false}
                enableVisualizar={false}
                enableAlterar={false}
                lockButtonsRules={({ situacao }) => ({
                    excluir: situacao?.codgSituacaoMeta !== 'CADASTRO',
                    editar: situacao?.codgSituacaoMeta !== 'CADASTRO',
                })}
                addAditionalActions={() => (
                    <Button
                        label="Cadastrar Meta"
                        icon="pi pi-plus"
                        iconPos="left"
                        className="p-button-info"
                        onClick={() => {
                            if (situacaoIndicador?.codgSituacaoIndicador === 'ATIVO') {
                                modalRef.current.show();
                            } else {
                                confirmOkRef.current.show(
                                    PageMessages.sei.metasResultados.inclusaoNaoPermitida
                                );
                            }
                        }}
                    />
                )}
                addBeforeActions={({ id }) => (
                    <>
                        <ButtonSeplag
                            tipo="info"
                            type="button"
                            tooltip="Visualizar"
                            tooltipOptions={{ position: 'top' }}
                            icon="pi pi-eye"
                            onClick={() => modalRef.current.show({ id, view: true })}
                            style={{
                                marginRight: '.5em',
                                marginTop: '.2em',
                            }}
                        />
                        <ButtonSeplag
                            tipo="warning"
                            type="button"
                            tooltip="Editar"
                            tooltipOptions={{ position: 'top' }}
                            icon="pi pi-pencil"
                            onClick={() => {
                                if (situacaoIndicador?.codgSituacaoIndicador === 'ATIVO') {
                                    modalRef.current.show({ id });
                                } else {
                                    confirmOkRef.current.show(
                                        PageMessages.sei.metasResultados.alteracaoNaoPermitida
                                    );
                                }
                            }}
                            style={{ marginRight: '.5em', marginTop: '.2em' }}
                        />
                    </>
                )}
                addAfterActions={({ id, descMotivoCancelamento, situacao }) => (
                    <ButtonSeplag
                        tipo="danger"
                        type="button"
                        tooltip="Cancelar"
                        tooltipOptions={{ position: 'top' }}
                        icon="pi pi-ban"
                        className="p-button-danger p-mb-1"
                        onClick={() =>
                            modalCancelarRef.current.show({
                                id,
                                descMotivoCancelamento,
                                situacao,
                            })
                        }
                        style={{ marginLeft: '.5em', marginTop: '.2rem' }}
                    />
                )}
            >
                <BaseFilter
                    ref={baseFilterRef}
                    service={metaService}
                    initialValues={metaInputs.filter((el) => el?.filter?.use ?? false)}
                    prepareInitialValues={async (dados) => ({
                        ...dados,
                        indicador: { id: idIndicador },
                    })}
                    customFilter={{
                        indicador: ({ nameUse }) => builder.comparison(nameUse, '==', idIndicador),
                    }}
                >
                    <Inputs />
                </BaseFilter>
            </BasePage>
        </>
    );
}

export default MetasList;
